import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { RePay } from "./RePay";
import {
  SlBusyIndicator,
} from "../editors";
import {
  metadataService,
  LoanInfoApi as loanInfoService,
  registrationService,
  workflowService,
  SessionService,
} from "../../_services";
import { workflowConstants } from '../../_constants';

class InstantFunding extends Component {
  static displayName = InstantFunding.name;

  constructor(props) {
    super(props);

    this.state = {
      isBusy: true,
      repayUrl: "",
      submitted: false,
      iframeStyle: {
        minHeight: "95vh",
        width: "100%",
        border: "0px", 
        display: "flex",
        justifyContent: "center",
        flexDirection: "row"
      },
    };
    this.handleRePayMessage = this.handleRePayMessage.bind(this);
  }
  componentDidMount() {
      this.setState({ isBusy: true });

      var dateOfBirth,
          socialSecurityNumber,
          individualTaxIdentificationNumber,
          firstName,
          lastName,
          userHash;

      let workflowData = workflowService.getCurrentWorkflowStepData();
      if (workflowData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW) {
          const changeLoanInfo = JSON.parse(sessionStorage.getItem("changeLoanRequest"));
          var {
              dateOfBirth,
              socialSecurityNumber,
              individualTaxIdentificationNumber,
              firstName,
              lastName,
              userHash
          } = changeLoanInfo;
      } else {
          const registrationPersonalInfo = SessionService.getPersonalInfo();
          if (registrationPersonalInfo) {
              var {
                  dateOfBirth,
                  socialSecurityNumber,
                  individualTaxIdentificationNumber,
                  firstName,
                  lastName,
                  userHash
              } = registrationPersonalInfo;
          }
      }

      if (userHash) {
          this.getRepayUrl({
              userHash,
              firstName,
              lastName
          });
      } else {
          registrationService
              .getUserHash({
                  DateOfBirth: dateOfBirth,
                  SSN: socialSecurityNumber || individualTaxIdentificationNumber,
              })
              .then((getUserHashResponse) => getUserHashResponse.data)
              .then((userHash) => {
                  this.getRepayUrl({
                      userHash,
                      firstName,
                      lastName
                  });
            });
      }
}
getRepayUrl = (requestData) => {
    const {
        userHash,
        firstName,
        lastName
    } = requestData;

    loanInfoService
        .getInstantFundingUrl({
            userHash,
            firstName,
            lastName,
            isMobile: window.innerWidth <= 768,
        })
        .then(
            (getInstantFundingUrlResponse) =>
                getInstantFundingUrlResponse.data
        )
        .then((repayUrl) => {
            this.setState({
                repayUrl: repayUrl,
                isBusy: false,
            });
        }
    );
}
  handleRePayMessage = (args) => {
    this.props.onRePayMessage(args);
    if(typeof args === "string" && args === "PAYMENT_SUCCESS"){
        const {iframeStyle} = this.state    
        this.setState({
          iframeStyle: {
            ...iframeStyle,
            minHeight:"600px",
          },
        });
    } 
  };

  render() {
    const { isBusy, repayUrl, iframeStyle } = this.state;

    return (
      <div>
        {(isBusy === false && (
          <div>
            <Card>
              <CardBody className="p-0 m-0">
                <Row>
                  <Col className="p-0 m-0">
                    <RePay
                      repayUrl={repayUrl}
                      onMessage={this.handleRePayMessage}
                      iframeStyle={iframeStyle}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )) || <SlBusyIndicator visible={isBusy} />}
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { error, errorString } = state.newLoan;
  const { loggedIn } = state.authentication;
  const { token } = state.authentication;
  return {
    error,
    errorString,
    token,
    loggedIn,
  };
}
InstantFunding.propTypes = {
  onRePayMessage: PropTypes.func,
  hideNext: PropTypes.bool,
};

InstantFunding.defaultProps = {
  hideNext: false,
};
const connectedFindOffice = connect(mapStateToProps)(InstantFunding);
export { connectedFindOffice as InstantFunding };
